import { createFileRoute } from "@tanstack/react-router"

import { LegalVersionPage } from "@/components/content/legal-version-page"
import {
  currentLegalVersion,
  lazyLegalModules,
  loadCurrentLegalVersion,
  resolveLegalVersions,
} from "@/lib/legal-versions"
import { seoMeta } from "@/lib/seo"

const modules = lazyLegalModules(import.meta.glob("../-content/subprocessors/*.md"))

export const Route = createFileRoute("/_content/subprocessors/")({
  head: () =>
    seoMeta({
      title: "Subprocessor List",
      description:
        "The third-party subprocessors Entire engages to process customer personal data.",
      url: "https://entire.com/subprocessors",
      image: "https://entire.com/og/page/subprocessors.png",
    }),
  loader: () => loadCurrentLegalVersion(modules),
  component: SubprocessorsPage,
})

function SubprocessorsPage() {
  const { asOf } = Route.useLoaderData()
  const versions = resolveLegalVersions(modules, asOf)
  const current = currentLegalVersion(versions)!
  return <LegalVersionPage basePath="/subprocessors" version={current} versions={versions} />
}
